<template>
	<div class="header">
		<div class="header-left">
			<TnParagraph
				:bold="true"
				:class="{ active }"
			>
				{{ store.name }}
			</TnParagraph>
			<TnParagraph size="s">
				{{ storeAddress }},
				<a
					class="phone-number"
					:href="'tel:' + store.phoneNumber"
				>
					Tlf: {{ formattedPhoneNumber }}
				</a>
			</TnParagraph>
		</div>
		<div class="header-right">
			<EcommerceClickAndCollectStockStatus
				:stockQuantity="store.inventory?.quantity"
				:store="store"
			/>
		</div>
	</div>
</template>

<script>
import { formatPhoneNumber } from "~/helpers/ecommerce/phoneNumber";

export default {
	name: "ECommerceStoreCardHeader",
	props: {
		store: {
			type: Object,
			required: true,
		},
		active: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		storeAddress() {
			return this.store.address?.shoppingCentre || "";
		},
		formattedPhoneNumber() {
			return formatPhoneNumber(this.store.phoneNumber);
		},
	},
};
</script>

<style lang="scss" scoped>
.header {
	display: flex;
	justify-content: space-between;
	align-items: center;

	.header-left {
		flex-basis: 55%;

		.active {
			color: $color-primary-mid;
		}
	}

	.header-right {
		position: relative;
		top: -7px;

		.icon {
			position: relative;
			top: 7px;
		}
	}
}

.phone-number {
	margin-bottom: 4px;
	margin-left: 2px;
	font-size: 16px;
	color: $color-neutrals-800-shade;
	text-decoration: none;
}
</style>
